import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserEntitlements } from '@ddv/entitlements';

import { EditAction, HeaderNameEditComponent } from './header-name-edit/header-name-edit.component';
import { HeaderNameViewComponent } from './header-name-view/header-name-view.component';
import { DashboardDetails } from '../../models/dashboard-details';
import { Sharing } from '../../models/sharing';
import { ViewTile } from '../../models/view-tile';

export type EditActionWithEdit = EditAction | 'edit';

@Component({
    selector: 'ddv-dashboard-header-name',
    templateUrl: 'dashboard-header-name.component.html',
    styleUrls: ['./dashboard-header-name.component.scss'],
    imports: [
        HeaderNameViewComponent,
        HeaderNameEditComponent,
    ],
})
export class DashboardHeaderNameComponent {
    @Input() dashboard: DashboardDetails | undefined;
    @Input() sharing: Sharing | undefined;
    @Input() userEntitlements: UserEntitlements | undefined;
    @Input() inPresentationMode = true;
    @Input() isDirty = false;
    @Input() memberOf: ViewTile | undefined;

    @Output() editAction = new EventEmitter<EditActionWithEdit>();
    @Output() dashboardSwitch = new EventEmitter<string>();
}
